import React from 'react'
import { Route } from 'react-router'

// FLAG:docuAiEnhancements — "Meine Meldungen" (read-only customer-issue list + message thread);
// internal-only child of useDocuAi, the component redirects flag-OFF visitors to /dashboard
// (the baseline catch-all target, so flag-OFF behaviour is unchanged by this route existing).
// Deliberately bound to NO module right (no 'customer-issues' case in mapRouteToModule, same as
// /dashboard or /todo): an accounting-only user without DOCUMENTS/FILE can report an analysis
// problem from the expense/revenue review (see the /documents/review carve-out in
// protected-route.tsx) and must be able to read the answers to it here.
const CustomerIssuesList = React.lazy(() => import('./components/customer-issues-list'))

const customerIssuesRoutes = (
  <>
    <Route path='customer-issues' Component={CustomerIssuesList} />
  </>
)

export default customerIssuesRoutes
